import { Profile } from "PFTypes";
import jqXHR = JQuery.jqXHR;
import { ApiRoute } from "PFCore/utilities/routes";

export const fetchUser = (id: string): jqXHR<Profile> =>
  // @ts-ignore
  $.ajax({ url: ApiRoute(`/api/admin/users/${id}`) });
